export const text = {
  common: {
    mc: 'Merchant Contract',
    ts: 'Terms of Service',
    all: 'All',
  },
  login: {
    welcome: 'Welcome to Atome Merchant Center',
    username: 'Username',
    password: 'Password',
    forget: 'Forgot password?',
    login: 'Log in',
    incorrect: `User name or password is incorrect. If you forget your password, you can reset it by clicking ‘Forgot Password' below.`,
    placeholder: 'type your username/email',
    placeholder2: 'type your password',
  },
  profile: {
    setting: 'Account Setting',
    profile: 'Profile',
    company: 'Company',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    createTime: 'Created Time',
    subscription: 'Subscription',
    subscribe: 'Subscribe',
    editSubscription: 'Edit Subscription',
    dailyPayoutReport: 'Daily Payout Report',
    dailyTransReport: 'Daily Transaction Report',
    changePwd: 'Change Password',
    logout: 'Log Out',
    username: 'User Name',
    outlet: 'Outlet',
    password: 'Password',
    language: 'Language',
  },
  roleList: {
    roleMana: 'Role Management',
    addRole: 'Add Role',
    roleName: 'Role name',
    time: 'Create time',
    action: 'Action',
    confirmDel: 'Confirm deleting role ',
    delete: 'Delete',
    deleteTip: 'Are you sure you want to delete the role {{roleName}}? This action cannot be reversed.',
    desc: 'Description',
    roleDetail: 'Role Details',
    cancel: 'Cancel',
    edit: 'Edit',
    success: 'Delete successfully',
    failed: 'Failed to delete the role , please try again later',
  },
  role: {
    roleName: 'Role name',
    permissions: 'Permissions',
    desc: 'Description',
    confirm: 'Confirm',
    cancel: 'Cancel',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    required1: `'Role Name' is required.`,
    required2: `'Permission' is required.`,
    select: 'Please select',
    success: `You've successfully edited this role`,
    success2: `You've successfully created a new role`,
  },
  userList: {
    userMana: 'User Management',
    addUser: 'Add User',
    role: 'Role',
    userName: 'User name',
    search: 'Search',
    email: 'Email',
    time: 'Create time',
    action: 'Action',
    edit: 'Edit',
    del: 'Delete',
    userDetail: 'User Detail',
    delTip: 'Are you sure you want to delete the user {{userName}}? This action cannot be reversed.',
    delTitle: 'Confirm deleting user {{userName}}',
    delSuccess: `You've successfully deleted user {{userName}}.`,
  },
  user: {
    editUser: 'Edit User',
    addUser: 'Add User',
    userName: 'User name',
    email: 'Email',
    time: 'Create time',
    role: 'Role',
    outlet: 'Outlet',
    password: 'Password',
    reset: 'Reset Password',
    good:
      'A good password is a mix with uppercase letters , lowercase letters, numbers, and at least 8 character length.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    required1: `'User Name' is required.`,
    required2: `'Role' is required'`,
    required3: `'Outlet' is required'`,
    required4: `'Password' is required'`,
    select: 'Please select',
    weak: 'Your password is too weak, make sure you fulfil the password strength requirement.',
    success: `You've successfully created new user account.`,
    poor: 'Poor',
    medium: 'Medium',
    good2: 'Good',
    excellent: 'Excellent',
    tip: `Characters allowed in your username include: A-Z, a-z, 0-9, '.',  '_', '@'.`,
    emailTip: `Please make sure this email address is correct-We'll send emails to it when you forget password.`,
    emailErrMsg: 'Please input a valid email address',
  },
  analytics: {
    all: 'All',
    analytics: 'Analytics',
    period: 'Period',
    frequency: 'Frequency',
    weekly: 'Weekly',
    monthly: 'Monthly',
    vs: 'vs. Previous period',
    outlet: 'Outlet',
    allTime: 'All Time',
    last4Weeks: 'Last 4 Weeks',
    last3Months: 'Last 3 Months',
    weeklyDesc: 'Weekly: Starts from Mon.',
    monthlyDesc: 'Monthly: Starts from 1st.',
  },
  charts: {
    order: 'Order',
    total: 'Total Transaction Value (Including refunded orders):',
    totalCount: 'Total Order Count (Including refunded orders):',
    ave: 'Average Transaction Value:',
    data: 'The demographics data is collected per order.',
    cd: 'Customer demographics',
    ot: 'Online Traffic',
    others: 'Others',
    age: 'Age Group',
    majority: 'Majority',
    type: 'Card Type',
    cr: 'Credit card',
    dc: 'Debit card',
    pc: 'Prepaid card',
    gender: 'Gender',
    female: 'Female',
    male: 'Male',
    current: 'Current',
    previous: 'Previous',
    exposure: 'Exposure',
    leads: 'Leads',
    weekly: 'WEEKLY',
    hover1: 'This chart shows the number of times customers have seen your store in Atome app.',
    hover2: 'This chart shows the number of times that customers have been redirected to your website from Atome app.',
    hover1Dec:
      'This chart shows the number of times customers have seen your store in Atome App only from 01 Dec 2020.',
    hover2Dec:
      'This chart shows the number of times that customers have been redirected to your website from Atome App from 01 Dec 2020.',
    count: 'Sponsored Voucher Usage Count',
    amount: 'Sponsored Voucher Amount',
  },
  password: {
    old: 'Old Password',
    new: 'New password',
    retype: 'Retype Password',
    change: 'CHANGE PASSWORD',
    tip:
      'A good password is a mix with uppercase letters , lowercase letters, numbers, and at least 8 character length.',
    notMatch: 'Password entered do not match.',
    tooWeak: 'Your password is too weak, make sure you fulfil the password strength requirement.',
    notCorrect: 'Old password is incorrect.',
    success: 'Successfully reset password',
    poor: 'Poor',
    medium: 'Medium',
    good2: 'Good',
    excellent: 'Excellent',
    error: 'Network error',
    wrong: 'Sorry, your user name or email is wrong, please try again.',
    receive: 'You will receive a password reset email if you have registered an account with us.',
    ops: `Oops...something's wrong. Please refresh and try again or you can contact us at {{contactEmail}}`,
    forget: 'Forgot your password?',
    noWorry: 'No worries!',
    userName: 'User Name',
    email: 'Email',
    tip2:
      'If you have registered an account with us, please key it in below and we will send you an email to reset your password.',
    invalid: 'Invalid email format',
    your: 'Your user name',
    send: 'Send',
    reset: 'Password has been reset, please login again.',
    welcome: 'Welcome!',
    needToChange:
      'As this is your first log in, you will need to agree to the merchant contract and change your password.',
  },
  subscription: {
    subscriptionPayout: 'Subscribe to Payout Report via Email',
    subscriptionTransaction: 'Subscribe to Transaction Report via Email',
    titlePayout: 'An email with the settlement report of yesterday will be sent to you at 8am everyday.',
    titleTransaction: 'An email with the transaction report of yesterday will be sent to you at 8am everyday.',
    displayBy: 'Record Display By',
    recipient: 'Recipient',
    cc: 'cc',
    bcc: 'bcc',
    unsubscribe: 'Unsubscribe',
    confirm: 'Confirm',
    item: 'Settlement Item',
    trans: 'Settlement transaction',
    error1: 'Recipient email format is invalid, please check and input again',
    error2: 'CC email format is invalid, please check and input again',
    error3: 'BCC email format is invalid, please check and input again',
    successPayout: `You've successfully subscribed the settlement report.`,
    successTransaction: `You've successfully subscribed the transaction report.`,
    success2Payout: `You've successfully unsubscribed the settlement report.`,
    success2Transaction: `You've successfully unsubscribed the transaction report.`,
  },
  transaction: {
    detail: 'Transaction Details',
    notFound: 'Record not found',
    refund: 'Refund',
    maxAmount: 'Maximum amount available for refund',
    refundAmount: 'Refund Amount',
    confirm: 'Confirm',
    close: 'Close',
    errMsg1: 'Fail to proceed with your refund request. Try again later.',
    transId: 'Transaction ID',
    date: 'Transaction Date and Time',
    status: 'Status',
    transAmount: 'Transaction Amount',
    confirmed: 'Confirmed',
    settled: 'Settled',
    refundStr: '{{amount}} refund has been processed at {{timeStr}}',
    timeFormat: '{{time}} on {{date}}',
    refundId: 'Refund Transaction ID',
    range: 'Available refund range',
    to: 'to',
    inclusive: 'inclusive',
    amountBreak: 'Amount Breakdown',
    amountFee: 'Atome Fees:',
    amountFeeVat: 'Atome Fees VAT:',
    amountFeeWht: 'Atome Fees WHT:',
    history: 'History',
    wrongParams: 'Atome reversed this transaction due to wrong parameters. If you have any questions, please contact',
    reversed: 'This transaction has been reversed.',
    transactionId: 'Transaction ID',
    outlet: 'Outlet',
    transactionDate: 'Transaction Date and Time',
    transactionAmount: 'Transaction Amount',
    amountReceivable: 'Amount Receivable',
    transactionType: 'Transaction Type',
    atomeId: 'Atome Order ID',
    eId: 'E-commerce Platform Order ID',
    voucherAmount: 'Sponsored Voucher Amount',
    adjusted: 'Adjusted',
    REFUND: 'Refund',
    MERCHANDISE: 'Merchandise',
    ADJUSTMENT: 'Adjustment',
    reversed2: 'This transaction has been reversed, please make refund from TXN',
    transOutlet: 'Transaction Outlet',
    customerName: 'Customer Name',
    phone: 'Phone Number',
    reversed3: 'Atome reversed this transaction. You can find the corrected details via TXN ',
    reversed4: '.',
    transactions: 'Transactions',
    error: 'Sorry, network unavailable, please try again later.',
    name: 'Name',
    createPayment: 'Create payment link',
    transactionStatus: 'Transaction Status',
    date2: 'Date',
    selectOutlet: 'Select Outlet',
    mobile: 'Mobile Phone',
    orderId: 'Atome Order ID',
    eOrderId: 'E-commerce Platform Order ID',
    search: 'Search',
    export: 'Export',
    tip: 'Please make sure the start and end dates that you have chosen are within one month.',
    ALL: 'All',
    UNSETTLED: 'Confirmed',
    SETTLED: 'Settled',
    today: 'Today',
    last7: 'Last 7 days',
    last30: 'Last 30 Days',
    all: 'All',
  },
  welcome: {
    change: 'CHANGE PASSWORD',
    welcome: 'Welcome!',
    needToAgree: 'As this is your first log in, you will need to agree to the merchant contract.',
    needToAddEmail:
      'As this is your first log in, you will need to input an email address and agree to the merchant contract.',
    needToChange:
      'As this is your first log in, you will need to agree to the merchant contract and change your password.',
    agree: 'I agree to the',
    contract: 'Merchant Contract',
    ok: 'OK',
    emailExtra:
      'Please make sure this email address is correct-We’ll send an email to it when you forget your password.',
    emailErrMsg: 'Please input a valid email address',
    emailPlaceholder: 'Input your email address',
  },
  dashboard: {
    dashboard: 'Dashboard',
    overview: 'Overview',
    totalTrans: 'Total Number of Merchandise Transactions',
    totalAmount: 'Total Transaction Amount',
    totalRefundTrans: 'Total Number of Refund Transactions',
    totalRefundAmount: 'Total Refund Amount',
    today: 'Today',
    last7: 'Last 7 days',
    last30: 'Last 30 Days',
    all: 'All',
    transaction: 'Transaction',
    confirmed: 'Confirmed',
    settled: 'Settled',
    moreTrans: 'More Transactions',
    activity: 'Activity',
    wrong: 'Sorry, your user name or email is wrong, please try again.',
    receive: 'You will receive a password reset email if you have registered an account with us.',
    ops: `Oops...something's wrong. Please refresh and try again or you can contact us at {{contactEmail}}`,
    forget: 'Forgot your password?',
    noWorry: 'No worries!',
    userName: 'User Name',
    email: 'Email',
    invalid: 'Invalid email format',
    your: 'Your user name',
    send: 'Send',
  },
  company: {
    payments: 'Payments',
    payout: 'Payout',
    dashboard: 'Dashboard',
    transactions: 'Transactions',
    balance: 'Balance',
    ana: 'Analytics',
    roleMana: 'Role Management',
    userMana: 'User Management',
    help: 'Help',
    accountMana: 'Account Management',
  },
  payments: {
    sale: 'Sale',
    atomeFee: 'Atome Fees',
    rebate: 'Rebate',
    voucher: 'Sponsored Voucher',
    all: 'All',
    balance: 'Balance',
    outBalance: 'Outstanding Balance',
    outlet: 'Outlet',
    total: 'Total',
    atomeFeeVAT: 'Atome Fees VAT',
    rebateVAT: 'Rebate VAT',
    rebateWHT: 'Rebate WHT',
    atomeFeeWHT: 'Atome Fees WHT',
    id: 'Payout ID',
    detail: 'Payout Details',
    viewLevel: 'View Level',
    settlementItem: 'Settlement Item',
    settlementItemTip: 'Each transaction is broken down to different settlement items, such as: Sale, Atome Fees.',
    settlementTran: 'Settlement transaction',
    settlementTranTip: 'There will only be one record for each transaction in one payout.',
    tranId: 'Transaction ID',
    tranType: 'Transaction Type',
    tranDate: 'Transaction Date',
    tranAmount: 'Transaction Amount',
    amountRe: 'Amount Receivable',
    amountPayout: 'Amount Payout',
    error: 'Sorry, network unavailable, please try again later.',
    summary: 'Summary',
    export: 'Export',
    subscription: 'Subscription',
    payoutMade: 'Payout made from Atome to your bank account.',
    date: 'Payout Date',
    outletName: 'Outlet Name',
    allSettledCount: 'All Settled Transactions Count',
    allSettledItemCount: 'All Settled Items Count',
    saleCount: 'Sale Count',
    atomeFeeCount: 'Atome Fees Count',
    voucherCount: 'Sponsored Voucher Count',
    vatCount: 'Atome Fees VAT Count',
    rebateVatCount: 'Rebate VAT Count',
    whtCount: 'Atome Fees WHT Count',
    rebateWhtCount: 'Rebate WHT Count',
    rebateCount: 'Rebate Count',
    payoutAmount: 'Payout Amount',
    payoutStatus: 'Status',
    inTransit: 'In Transit',
    paid: 'Paid',
    payout: 'Payout',
    date2: 'Date',
    today: 'Today',
    last7: 'Last 7 days',
    last30: 'Last 30 Days',
  },
  download: {
    export: 'Export',
    close: 'Close',
    ready: `Your export is ready. If you don't see your file,`,
    preparing: 'Preparing export...',
    remaining: 'A few seconds remaining...',
    again: 'you can try downloading it again.',
    wrong:
      'Some thing went wrong with your export. We&apos;re looking into it now, please try again later, or get in touch with our support team',
  },
  help: {
    help: 'Help',
    dashboard: 'Dashboard',
    h1:
      'What do “Total number of merchandise transaction”, “Total amount of merchandise transaction”, “Total number of refund”, and “Total amount of refund” mean?',
    p1: `Each field will show corresponded data in the chosen time duration.<br/>
Total number of merchandise transaction: the total number of merchandise transactions via Atome (for this merchant account only)<br/>
Total amount of merchandise transaction: the total amount of merchandise transactions via Atome (for this merchant account only)<br/>
Total number of refund: the total number of refunds made (for this merchant account only)<br/>
Total amount of refund: the total amount of refunds made (for this merchant account only)<br/>
*Please note that, currently, synchronization of transaction data between all branches is not supported.`,
    h2: 'What will be displayed in “activity” table?',
    p2:
      'The activity table will show the latest transactions via Atome (including settled orders, confirmed orders and refund orders).',
    h3: 'Will I be able to track orders that use Atome vouchers on the merchant dashboard?',
    p3: 'Currently this is not available.',
    transTable: 'Transaction Table',
    h4: 'How does “filter” work?',
    p4: `This feature allows you to check sales over a selected time duration. You can view the results by selecting different order status and order types. In addition, you can search for orders by the user's phone number or Atome order ID. Note that the table only displays data for a selected period of time.`,
    h5: 'What are the definitions of different status?',
    p5: `The status can help you to filter settled orders and confirmed orders.<br/>
Confirmed orders: when a transaction occurs, the order status will display 'confirmed'.<br/>
Settled orders: this status will only be shown until the financial team settles successfully.`,
    h6: 'How to use “phone number” and “order ID” to search in transaction dashboard?',
    p6: `The phone number is what users registered with. Use the phone number to filter can show you all the orders (including settled, confirmed, and refunds) this user made in your chosen time duration.<br/>
The order ID should be the transaction ID in the Atome system. This can be used to search for a single order.`,
    h7: 'How to export the data to excel file?',
    p7: `Click 'export' to download the CSV. files of data you filtered. The files can be opened in excel or any software supporting this format.`,
    companyInfo: 'Company Information',
    h8: 'How to make changes to my company information?',
    p8: `Please contact and inform Atome account management team the reasons of changing your company information. Once it's confirmed, they will help you to change it in xx working days.`,
    h9: 'Is there a limit of how many times I can change my company information?',
    p9: `No, we don't have any limits on this. But kindly note that please inform our team of the reasons when you want to make changes.`,
    account: 'Account & Passwords',
    h10: 'What is my username and initial passwords?',
    p10:
      'The username and initial passwords should be included in the onboarding emails sent to you. For any uncertainty, please contact your account manager directly.',
    h11: 'What if I forget my passwords?',
    p11: `The new passwords can be set via emails.<br/>
Click 'forget passwords' in the Login page and verify your email address. An email with a reset link will be sent to your box in a few minutes.<br/>
If you were not onboarded with any email address, please contact your account managers directly to reset your passwords.`,
    h12: 'How to change/reset my passwords?',
    p12: `Enter 'profile' and click 'change passwords'. The new passwords cannot be same with the old one.<br/>
A good password is a mix with uppercase letters , lowercase letters, numbers, and at least 8 character length.`,
    h13: 'Is there a limit of how many times I can change my passwords?',
    p13: `No, we don't have any limits on this.`,
    h14: 'Can I create multiple passwords for each branch account?',
    p14: `Yes, this is available. For more details, please contact your account manager to finish setting multiple passwords.`,
    refund: 'Refund',
    h15:
      'If I commence a refund, will the commissions that Atome takes be returned to me? Is it before or after the refund?',
    p15: 'The commissions taken by Atome will be returned to your account after the refund.',
    h16: 'Can I commence a refund from a master account?',
    p16: `Yes, you can refund from Shop Manager account or Company Admin account or any accounts created by your company with 'Refund' permissions.`,
    h17: `If I'm an online merchant, will the refunds done on third-party platform be synchronized to the Atome merchant center?`,
    p17: `Yes, all the refunds done in third-party platforms will be synchronized to the Atome merchant center, but it is advised that there may be some data delay.<br/>
However, please note that the refunds done in the Atome merchant center will not be displayed on any third-party platforms.`,
    needHelp: 'Can’t find the answers you’re looking for? We’re here to help.',
    reach: 'Please reach us at:',
    reach2: '',
  },
};
